import React from "react";
import { PrimaryButton } from "@fluentui/react";
import { attachmentUtil } from "../services/AttachmentUtil";

export interface IInputFileButtonProps {
  text: string;
  accept: string;
  onChange: (files: File[]) => void | Promise<void>;
  allowMultipleFiles?: boolean;
}

export default class InputFileButton extends React.Component<IInputFileButtonProps> {
  private fileInputRef!: React.RefObject<HTMLInputElement>;

  constructor(props: Readonly<IInputFileButtonProps>) {
    super(props);
    this.fileInputRef = React.createRef();
  }

  private fileSelectedHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files || event.target.files.length !== 1) return;
    const attachments = Array.from(event.target.files).filter((file) =>
      attachmentUtil.isValidFileExtension(file.name, this.props.accept)
    );
    this.props.onChange(attachments);
  };

  private fileInputRefHandler = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  public render(): JSX.Element {
    const { text, accept, allowMultipleFiles = false } = this.props;

    return (
      <React.Fragment>
        <input
          type="file"
          onChange={this.fileSelectedHandler}
          name="InputFile"
          style={{ display: "none" }}
          ref={this.fileInputRef}
          accept={accept}
          multiple={allowMultipleFiles}
        />
        <PrimaryButton text={text} onClick={this.fileInputRefHandler} />
      </React.Fragment>
    );
  }
}
